import { useEffect, useSyncExternalStore } from 'react'

const STORAGE_KEY = 'tendbot-labs'

let snapshot = false
const listeners = new Set<() => void>()

function readFlag(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

function processUrlParams() {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  if (!params.has('showLabs')) return
  try {
    if (params.get('showLabs') === 'true') {
      localStorage.setItem(STORAGE_KEY, 'true')
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
    snapshot = readFlag()
    listeners.forEach((cb) => cb())
  } catch { /* localStorage unavailable */ }
}

// Process URL params on module load (works in bundled builds)
processUrlParams()

// Initialize snapshot from localStorage
snapshot = readFlag()

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

function getSnapshot() {
  return snapshot
}

// Listen for storage changes from other tabs
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) {
      snapshot = readFlag()
      listeners.forEach((cb) => cb())
    }
  })
}

export function useLabs(): boolean {
  // Re-check URL params on mount as a fallback (handles race conditions
  // in Vite dev mode where URL may be modified between module evaluations)
  useEffect(() => {
    processUrlParams()
  }, [])

  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}
